/**
 * App-wide keyboard shortcuts, in one place so two surfaces can never claim
 * the same chord. Every predicate takes the raw keydown event.
 */

/** ⌘K / Ctrl+K — the command palette. */
export function isCommandPaletteShortcut(event: KeyboardEvent): boolean {
  return (
    (event.metaKey || event.ctrlKey) &&
    !event.shiftKey &&
    !event.altKey &&
    event.key.toLowerCase() === 'k'
  );
}

/**
 * ⌘⇧O / Ctrl+Shift+O — a new chat. ⌘⇧N is reserved by every browser for
 * a new window, so the chord follows the chat convention instead.
 */
export function isNewChatShortcut(event: KeyboardEvent): boolean {
  return (
    (event.metaKey || event.ctrlKey) &&
    event.shiftKey &&
    !event.altKey &&
    event.key.toLowerCase() === 'o'
  );
}

export const NEW_CHAT_SHORTCUT_LABEL = '⌘⇧O';
